(() => {
  const projectPagePattern = /(^|\/)pages\/project-\d+\/?$/;
  const homeHeroSectionIds = ['image_hero_01', 'image_hero_02', 'image_hero_03'];

  function isHomePage() {
    return document.body.classList.contains('template-index');
  }

  function addHomePageElements(elements) {
    homeHeroSectionIds.forEach((sectionId) => {
      const section = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (!section) return;

      const media = section.querySelector('.image-hero__image-container');
      const text = section.querySelector('.image-hero__text-container-inner');

      if (media) {
        media.classList.add('orevoir-scroll-reveal--home-media');
        elements.push(media);
      }

      if (text) {
        text.classList.add('orevoir-scroll-reveal--home-text');
        elements.push(text);
      }
    });
  }

  function addProjectPageElements(elements) {
    document
      .querySelectorAll([
        '[data-section-type="image-with-text-split"] .image-with-text-split__image-container',
        '[data-section-type="image-with-text-split"] .image-with-text-split__text-container-inner',
        '[data-section-type="featured-collection-grid"] .featured-collection-grid__meta',
        '[data-section-type="featured-collection-grid"] .featured-collection-grid__product',
        '[data-section-type="project-navigation"] .orevoir-project-navigation__card',
      ].join(','))
      .forEach((element) => {
        element.classList.add('orevoir-scroll-reveal--project');
        elements.push(element);
      });
  }

  function initializeScrollReveal() {
    const elements = [
      ...document.querySelectorAll('.orevoir-story-index__item'),
    ];

    if (window.location.pathname === '/blogs/projects') {
      document
        .querySelectorAll('main > .shopify-section')
        .forEach((section) => {
          if (section.querySelector('.image-hero')) {
            elements.push(section);
          }
        });
    }

    if (projectPagePattern.test(window.location.pathname)) {
      addProjectPageElements(elements);
    }

    if (isHomePage()) {
      addHomePageElements(elements);
    }

    const isProjectPage = projectPagePattern.test(window.location.pathname);
    const isOrevoirHome = isHomePage();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: isProjectPage || isOrevoirHome ? 0.08 : 0.12,
        rootMargin: isProjectPage || isOrevoirHome ? '0px 0px -24px' : '0px 0px -40px',
      }
    );

    elements.forEach((element) => {
      element.classList.add('orevoir-scroll-reveal');
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeScrollReveal);
  } else {
    initializeScrollReveal();
  }
})();
